import { ModalDialog } from './modal-dialog';
$(() => {
	$(document).on('click.action-button', '[data-button-action]', (e: Event) => {
		const $btn = $(e.target).closest('[data-button-action]');
		const confirmation: string | undefined = $btn.data('confirmation');
		const action: string = $btn.data('button-action');
		const successAction = $btn.data('on-success');

		// Both actions below prevent the native click anyway, so it's safe to stop it
		// up front and run the rest asynchronously after an optional confirmation.
		e.preventDefault();

		const run = () => {
			switch (action) {
				case 'modal-dialog-form': {
					const url = $btn.data('url');
					if (!url) {
						throw `url is required`;
					}
					ModalDialog.form(url).then(() => {
						$btn.trigger('data-button-action:success');
						if (successAction === 'reload') {
							window.location.reload();
						} else if (successAction === 'click') {
							const selector: string = $btn.data('click-element-selector');
							$(selector).trigger('click');
						}
					});
					break;
				}
				case 'ajax-request': {
					const url = $btn.data('url');
					if (!url) {
						throw `url is required`;
					}
					$.post(url).then(response => {
						$btn.trigger('data-button-action:success', response);
						if (successAction === 'reload') {
							window.location.reload();
						}
					});
					break;
				}
				default: {
					throw 'Unknown action';
				}
			}
		};

		if (confirmation) {
			ModalDialog.confirm(confirmation).then(confirmed => {
				if (confirmed) {
					run();
				}
			});
		} else {
			run();
		}
	});
});
